import React from "react";
import { NavLink, withRouter, useRouteMatch } from "react-router-dom";

function MastersSubHeader(props) {
  const NavUrl = ({ title, navPath }) => {
    const match = useRouteMatch(navPath);
    const _classanme = isNaN(match)
      ? "menu-item menu-item-active"
      : "menu-item";
    return (
      <li className={_classanme} aria-haspopup="true">
        <NavLink to={navPath} className="menu-link">
          <span className="menu-text">{title}</span>
        </NavLink>
      </li>
    );
  };

  return (
    <div className="header-bottom">
      <div className="container-fluid">
        <div className="header-navs header-navs-left" id="kt_header_navs">
          <div className="tab-content">
            <div
              className="tab-pane py-5 p-lg-0 show active"
              id="kt_header_tab_1"
            >
              <div
                id="kt_header_menu"
                className="header-menu header-menu-mobile header-menu-layout-default"
              >
                <ul className="menu-nav">
                  <NavUrl
                    title="Global Values"
                    navPath="/masters/global-values"
                  />
                  <NavUrl
                    title="Deco Methods"
                    navPath="/masters/deco-methods"
                  />
                  {/* <NavUrl
                    title="Deco Method Category"
                    navPath="/masters/deco-method-category"
                  /> */}
                  <NavUrl
                    title="Additional Locations"
                    navPath="/masters/additional-locations"
                  />
                  <NavUrl
                    title="BU RunCharge"
                    navPath="/masters/bu-run-charge"
                  />
                  <NavUrl
                    title="Color Pricing Category"
                    navPath="/masters/color-pricing-category"
                  />
                  <NavUrl
                    title="Exception Category"
                    navPath="/masters/exception-category"
                  />

                  <NavUrl
                    title="Category Secondary Option"
                    navPath="/masters/category-secondary-option"
                  />
                  <NavUrl
                    title="Setup Charges"
                    navPath="/masters/setup-charges"
                  />
                  <NavUrl
                    title="Products"
                    navPath="/masters/products"
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(MastersSubHeader);
